<template>
  <div class="container align-items-center justify-content-center text-center">
    <gradeCalc></gradeCalc>
    <!-- <ul>
      <li v-for="k, v in course_list" v-bind:key="k"><strong>{{ v }}</strong>:{{ k }}</li>
    </ul> -->
  <h2 class="display-6 p-4">Foundation</h2>
  <table class="table">
    <thead class="thead-dark">
      <tr>
        <th class="w-25">Course Code</th>
        <th class="w-75">Course Title</th>
      </tr>
    </thead>
    <tbody>
      <tr v-for="k, v in course_list_foundation" v-bind:key="k">
        <td><strong>{{ v }}</strong>
        </td>
        <td>{{ k }}
        </td>
      </tr>
    </tbody>
  </table>
  <h2 class="display-6 p-4">Diploma</h2>
  <table class="table">
    <thead>
      <tr>
        <th class="w-25">Course Code</th>
        <th class="w-75">Course Title</th>
      </tr>
    </thead>
    <tbody>
      <tr v-for="k, v in course_list_diploma" v-bind:key="k">
        <td><strong>{{ v }}</strong>
        </td>
        <td>{{ k }}
        </td>
      </tr>
    </tbody>
  </table>
  <h2 class="display-6 p-4">Degree</h2>
  <table class="table">
    <thead>
      <tr>
        <th class="w-25">Course Code</th>
        <th class="w-75">Course Title</th>
      </tr>
    </thead>
    <tbody>
      <tr v-for="k, v in course_list_degree" v-bind:key="k">
        <td><strong>{{ v }}</strong>
        </td>
        <td>{{ k }}
        </td>
      </tr>
    </tbody>
  </table>
  </div>
</template>

<script>
import gradeCalc from './components/gradeCalc.vue'

export default {
  name: 'App',
  components: {
    gradeCalc
  },
  data() {
    return {
      course_list_foundation: {
        'bscma1001': 'Mathematics For Data Science I',
        'bschs1001': 'English I',
        'bsccs1001': 'Computational Thinking',
        'bscma1002': 'Statistics For Data Science I',
        'bscma1003': 'Mathematics For Data Science II',
        'bschs1002': 'English II',
        'bscma1004': 'Statistics For Data Science II',
        'bsccs1002': "Programming in Python",
      },
      course_list_diploma: {
        'bsccs2001': "Database Management Systems",
        'bsccs2002': "Programming, Data Structures and Algorithms using Python",
        'bsccs2003': 'Modern Application Development I',
        'bsccs2004': 'Machine Learning Foundations',
        'bsccs2005': 'Programming Concepts using Java',
        'bsccs2006': 'Modern Application Development II',
        'bsccs2007': 'Machine Learning Techniques',
        'bsccs2008': 'Machine Learning Practice',
        'bscms2001': 'Business Data Management',
        'bscms2002': 'Business Analytics',
        'bscse2001': 'System Commands',
        'bscse2002': 'Tools in Data Science',
      },
      course_list_degree: {
        'bsccs3002': 'Software Testing',
        'bsccs3001': 'Software Engineering',
        'bsccs3004': 'Deep Learning',
        'bsccs3003': 'AI: Search  Methods for Problem Solving',
        'bscee4001': 'Speech Technology',
        'bscgn3001': 'Strategies for Professional Growth',
        'bscms3001': 'Design Thinking for Data-Driven App Development',
        'bscms4001': 'Industry 4.0',
        'bsccs3007': 'Privacy & Security in Online Social Media',
        'bscbt4001': 'Algorithmic Thinking in Bioinformatics',
        'bscbt4002': 'Big Data and Biological Networks',
        'bscgn3002': 'Financial Forensics',
        'bsccs3006': 'Introduction to Big Data',
        'bsccs4001': 'Data visualization',
        'bscms3002': 'Market Research',
        'bscma3001': 'Linear Statistical Models'
      }
    }
  }
}
</script>

<style>
#app {
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
  margin-top: 60px;
}

th, td {
  font-family: 'Montserrat', sans-serif;
}
</style>
